module.exports = {"140227100":"西坪镇","140227101":"倍加造镇","140227102":"周士庄镇","140227201":"吉家庄乡","140227202":"峰峪乡","140227204":"杜庄乡","140227205":"党留庄乡","140227207":"瓜园乡","140227209":"巨乐乡","140227211":"许堡乡","140227401":"湖东","140227402":"东街","140227403":"西街"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140227.json
// module id = 250
// module chunks = 0